import type { EnteringFund } from '../../types/finance';
import { readerLocale } from '../../i18n/language';

const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

/** A CALENDAR date (`yyyy-mm-dd`) shown as itself. `new Date('2026-11-02')` is UTC
 *  midnight, which a viewer west of Greenwich would read as 1 November - and the day a
 *  client's money starts counting is not something to be off by one on. */
export function calendarDate(day: string): string {
  const parts = DATE_ONLY.exec(day);
  if (!parts) return day;
  const utc = new Date(Date.UTC(Number(parts[1]), Number(parts[2]) - 1, Number(parts[3])));
  return utc.toLocaleDateString(readerLocale(), {
    year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC',
  });
}

/** The fund could not take a contribution in, for a reason of its own. Nothing is promised and no
 *  reason is given; the money is safe, and the Account Executive is who explains and helps. */
export const ENTRY_DECLINED_LINE =
  'Received — the series could not take this contribution in. Your money is safe. '
  + 'Talk to your Account Executive: they can help you, or you can ask for it back.';

/** What the client is told about one deposit that has not entered its fund yet. Money that
 *  is waiting for a place carries no date and no figure: nothing is promised about it. */
export function enteringFundLine(row: EnteringFund): string {
  if (row.could_not_enter) return ENTRY_DECLINED_LINE;
  if (row.awaiting_allocation) return 'Received — awaiting allocation';
  return row.enters_on
    ? `Starts on ${calendarDate(row.enters_on)}. Your term starts on that date.`
    : 'Received. We are confirming the date it starts.';
}
